import io from 'socket.io-client';

let socket;

const connectSocket = (authToken, userId, onJoinSuccess) => {
    socket = io(process.env.REACT_APP_SOCKET_URL, {
        transports: ['websocket'],
    });

    socket.on('connect', () => {
        if (socket && socket.connected) {
            socket.emit('join', { userId, token: authToken }, (response) => {
                if (response.success) {
                    if (onJoinSuccess) onJoinSuccess();
                }
            });
        }
    });

    socket.on('connect_error', (err) => {
        console.error('Connection error:', err);
    });
};

const listenToNotification = (callback) => {
    if (socket) {
        socket.on('response', (payload) => {
            callback({ success: true, data: payload });
        });
    }
};

const emitGetNotification = (userId, lastId) => {
    if (socket) {
        socket.emit('request', { event: 'getNotification', data: { userId, lastId } });
    }
};

const emitReadNotification = (type, notificationId) => {
    if (socket) {
        socket.emit('request', { event: 'readNotification', data: { type, notificationId } });
    }
};

const emitGetNotificationCount = (userId, userType) => {
    if (socket) {
        socket.emit('request', { event: 'getCounts', data: { userId, userType } });
    }
};

const disconnectSocket = () => {
    if (socket) {
        socket.disconnect();
    }
};

export { connectSocket, listenToNotification, disconnectSocket, emitGetNotification, emitGetNotificationCount, emitReadNotification };
